import axios from "axios";
import { get } from "lodash";
import { buildQueryString, authHeader } from "../utils/helpers";
import { persistUser } from "../store/AuthContext";
const { REACT_APP_SERVER_URL, REACT_APP_ORTHUS_URL, REACT_APP_API_BASIC_AUTH_USERNAME, REACT_APP_API_BASIC_AUTH_PASSWORD } = process.env;
const { REACT_APP_RIOT_URL } = process.env;

//axios.defaults.auth = {username: REACT_APP_API_BASIC_AUTH_USERNAME, password: REACT_APP_API_BASIC_AUTH_PASSWORD};
//axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;

const apiInstance = axios.create({
  baseURL: REACT_APP_SERVER_URL,
  headers: {
    'Content-Type': 'application/json',
    // 'X-Auth-Token': REACT_APP_RIOT_API_TOKEN
  },
});

const riotInstance = axios.create({
  baseURL: `${REACT_APP_SERVER_URL}/riot`,
  headers: {
    'Content-Type': 'application/json',
    // 'X-Auth-Token': REACT_APP_RIOT_API_TOKEN
  },
});

// unintercepted instance to ingnore global error handling
const riotDirectInstance = axios.create({
  baseURL: `${REACT_APP_SERVER_URL}/riot`,
  headers: {
    'Content-Type': 'application/json',
    // 'X-Auth-Token': REACT_APP_RIOT_API_TOKEN
  },
});

riotInstance.interceptors.request.use(request => {
  const user = JSON.parse(localStorage.getItem('user'));
  if (user) {
    request.headers["X-User-Id"] = user.id;
    request.headers["X-Person-Token"] = user.token;
    request.headers["X-Data-Silo-Code"] = 'cgo';
  }
  return request;
}, error => {
  return Promise.reject(error);
});

let refreshTokenPromise;
const onRefreshError = (refreshError) => {
  // Handle refresh token errors by clearing stored tokens and redirecting to the login page.
  console.error('Token refresh failed:', refreshError);
  localStorage.removeItem('user');
  window.location.href = '/login?from=refresh_error';
  return Promise.reject(refreshError);
}

riotInstance.interceptors.response.use(
  response => response, // Directly return successful responses.
  async error => {
    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry) {
      const errorKey = get(error, 'response.data.error.key');
      
      originalRequest._retry = true; // Mark the request as retried to avoid infinite loops.
      try {
        if(!refreshTokenPromise) {
          let user = JSON.parse(localStorage.getItem('user'));
          const access_token_ttl = localStorage.getItem("access_token_ttl")
          console.log('refresh token called');
          // Make a request to your auth server to refresh the token.
          refreshTokenPromise = riotDirectInstance.post(`/v1/people/reset_access_token`, {access_token_ttl}, {
            headers: {"X-Person-Refresh-Token": user.refreshToken},
          }).then(({data}) => {
            console.log('refresh complete');
            refreshTokenPromise = null;
            persistUser(data);
            return Promise.resolve(data);
          }).catch(error => {
            console.log('refresh error!');
            return onRefreshError('refresh token call failed');
          });
        } else {
          console.log('refresh token call already in progress');
        }
        
        return refreshTokenPromise.then(data => {
          console.log('refresh promise resolved')
          return riotInstance(originalRequest); // Retry the original request with the new access token.
        })
        
      } catch (refreshError) {
        return onRefreshError(refreshError)
      }
    }
    return Promise.reject(error); // For all other errors, return the error as is.
  }
);

apiInstance.interceptors.request.use(request => {
  const user = JSON.parse(localStorage.getItem('user'));
  if (user) {
    request.headers["X-User-Id"] = user.id;
    request.headers["X-Person-Token"] = user.token;
    request.headers["X-Data-Silo-Code"] = 'cgo';
  }
  return request;
}, error => {
  return Promise.reject(error);
});


export const loginRequestOrthus = (email, password) => {
  return axios.post(`${REACT_APP_ORTHUS_URL}/v1/users/sign_in`,{ email, password });
}

export const loginRequest = (email, password, ttl) => {
  return riotInstance.post(`v1/people/sign_in`,{ email, password, access_token_ttl: ttl }, { } );
}

export const logoutRequest = (id) => {
  return riotInstance.delete(`/v1/people/sign_out?person_id=${id}`, { } );
}

export const forgotPasswordRequest = (email) => {
  return riotInstance.post(`/v1/people/recovery_password`, { person_id: email }, { });
}

export const getOverviewRequestGET = ({ page, search, sort, type }) => {
  const { search: searchTerm, format, range: {start, end}} = search;
  const { headers } = authHeader();  
  return axios.get(
    `${REACT_APP_SERVER_URL}/api/overview?search=${searchTerm}&format=${format}&range_start=${start?start:''}&range_end=${end?end:''}&page=${page}&sort=${sort}`,
    { headers }
  );
};

export const getOverviewRequest = ({ page, pageSize, search, sort, all }) => {
  const { search: searchTerm, format, range: {start, end}} = search;
  const { headers } = authHeader();  
  return axios.post(
    `${REACT_APP_SERVER_URL}/api/overview?&page=${page}&page_size=${pageSize}&sort=${sort}&all=${all}`, {search }, 
    { headers }
  );
};


export const getSalesSummaryRequest = ({ upc, type, start, end }) => {
  const { headers } = authHeader();  
  return axios.post(
    `${REACT_APP_SERVER_URL}/api/sales/${type}/${start}/${end}`, {upc}, 
    { headers }
  );
};

export const getGoodsRequest = ({ upc, page, filters, sort }) => {
  const { headers } = authHeader();  
  return axios.post(
    `${REACT_APP_SERVER_URL}/api/goods?filter=${filters}&page=${page}&sort=${sort}`, {upc}, 
    { headers }
  );
};

export const getCurrentOrdersRequest = ({ upc, page, filters, sort }) => {
  const { headers } = authHeader();  
  return axios.post(
    `${REACT_APP_SERVER_URL}/api/orders?filter=${filters}&page=${page}&sort=${sort}`, {upc}, 
    { headers }
  );
};

export const getSalesOrdersRequest = ({ upc, start, end, mode, page, filters, sort }) => {
  const { headers } = authHeader();  
  return axios.post(
    `${REACT_APP_SERVER_URL}/api/sales_orders/${start}/${end}?mode=${mode}&filter=${filters}&page=${page}&sort=${sort}`, {upc}, 
    { headers }
  );
};

export const getSearchRequest = ({ query }) => {
  const { headers } = authHeader();  
  return axios.post(
    `${REACT_APP_SERVER_URL}/api/search/${query}`,
    { },
    { headers }
  );
};

export const getFormatsRequest = () => {
  const { headers } = authHeader();  
  return axios.get(
    `${REACT_APP_SERVER_URL}/api/search/formats`,
    { headers }
  );
};

export const getAccountTypesRequest = ({ page, search, sort, status }) => {
  const { headers } = authHeader();  
  return axios.get(
    `${REACT_APP_SERVER_URL}/api/account_types/${status}?search=${search}&page=${page}&sort=${sort}`,
    { headers }
  );
};

export const getGroupingRequest = () => {
  const { headers } = authHeader();  
  return axios.get(
    `${REACT_APP_SERVER_URL}/api/account_types/grouping`,
    { headers }
  );
};

export const getPendingCountRequest = () => {
  const { headers } = authHeader();  
  return axios.get(
    `${REACT_APP_SERVER_URL}/api/account_types/pending-count`,
    { headers }
  );
};

export const updateAccountTypeRequest = (data) => {
  const { headers } = authHeader();  
  return axios.patch(`${REACT_APP_SERVER_URL}/api/account_types`, data,
    { headers }
  );
};

export const getLabelsRequest = () => {
  return riotInstance.get(`/v1/labels`, {
  });
};

export const getUsersRequest = () => {
  const { headers } = authHeader();  
  return riotInstance.get(`/v1/people`, {
  });
};

export const getCurrentUserDetailsRequest = () => {
  const { headers } = authHeader();  
  return riotInstance.post(`/v1/people/details`, {}, {
  });
};

export const createUserRequest = (data) => {
  const { headers } = authHeader();  
  return riotInstance.post(`/v1/people`, data, {
  });
};

export const deleteUserRequest = (userId) => {  
  return riotInstance.delete(`/v1/people?person_id=${userId}`, {
  });
};

export const inviteUserRequest = (userId) => { 
  return riotInstance.post(`/v1/people/send_invite`, { person_id: userId }, {
  });
};


export const updateUserRequest = (data) => {
  return riotInstance.patch(`/v1/people`, data, {
  });
};

export const updatePasswordRequest = (data) => {
  return riotInstance.post(`${REACT_APP_RIOT_URL}/v1/people/change_password`, data, {
  });
};

export const getLastUpdatesRequest = () => {
  const { headers } = authHeader();  
  return axios.get(
    `${REACT_APP_SERVER_URL}/api/report/last-updates`,
    { headers }
  );
};

export const getParcelTrackingRequest = ({ catalogue_number, account_name, page, filters, sort }) => {
  const { headers } = authHeader();  
  return axios.post(
    `${REACT_APP_SERVER_URL}/api/parcel-tracking?filter=${filters}&page=${page}&sort=${sort}`, {catalogue_number, account_name}, 
    { headers }
  );
};


export const getSavedFiltersRequest = (type) => {
  const { headers } = authHeader();  
  return riotInstance.get(`/v1/person_options`, {
    params: {type}
  });
};

export const createSavedFilterRequest = (payload) => {
  const { headers } = authHeader();  
  return riotInstance.post(`/v1/person_options`, payload,  {
  });
};

export const updateSavedFilterRequest = (id, payload) => {
  const { headers } = authHeader();  
  return riotInstance.patch(`/v1/person_options/${id}`, payload,  {
  });
};

export const deleteSavedFilterRequest = (id) => {
  const { headers } = authHeader();  
  return riotInstance.delete(`/v1/person_options/${id}`,  {
  });
};

export const getCurrentSavedFilterDetailsRequest = (id) => {
  const { headers } = authHeader();  
  return riotInstance.get(`/v1/person_options/${id}`,  {
  });
};

export const getCatalogRequest = ({ page, pageSize, search, sort, all }) => {
  const { headers } = authHeader();  
  return axios.post(
    `${REACT_APP_SERVER_URL}/api/catalog-stock-sales?&page=${page}&page_size=${pageSize}&sort=${sort}&all=${all}`, {search}, 
    { headers }
  );
};

export const getReportPartnersRequest = () => {
  const { headers, imprints } = authHeader();  
  return axios.get(
    `${REACT_APP_SERVER_URL}/api/report/partners`,
    { headers }
  );
};

export const addReportRequest = (data) => {
  const { headers, imprints } = authHeader();  
  return axios.post(
    `${REACT_APP_SERVER_URL}/api/report/add`, data, 
    { headers }
  );
};

export const deleteReportRequest = (id) => {
  const { headers, imprints } = authHeader();  
  return axios.delete(
    `${REACT_APP_SERVER_URL}/api/report/delete/${id}`, 
    { headers }
  );
};

export const getLogEntriesRequest = () => {
  const { headers, imprints } = authHeader();  
  return axios.get(
    `${REACT_APP_SERVER_URL}/api/import/logs`,
    { headers }
  );
};

export const getAccountMetadataRequest = (params) => {
  const { headers, imprints } = authHeader();  
  return axios.post(
    `${REACT_APP_SERVER_URL}/api/report/account-metadata`,
    params,
    { headers }
  );
};

export const getCatalogMetadataRequest = (params) => {
  const { headers, imprints } = authHeader();  
  return axios.post(
    `${REACT_APP_SERVER_URL}/api/report/catalog-metadata`,
    params,
    { headers }
  );
};
